import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TooltipWrapper, TextWrapper, NewFeaturesWrapper } from './styles';
import IconFont from '../../../components/shared/IconFont';
import Label from '../../../components/shared/Label';

class FavouritesTooltip extends Component {
  rendertext = () => {
    const {
      dictionary,
      customText,
      noStar,
      newFeatures,
    } = this.props;
    return (
      <TextWrapper>
        {!noStar &&
        <IconFont
          className="icon-matchcenter-star"
          withCursor
          font={20}
          color="selectedColor"
          marginRight={0.3}
        />
        }
        <Label
          color="white"
          label={!customText ? dictionary.add : customText}
          size={0.8}
          lineHeight={newFeatures ? '1.3':'1'}
        />
      </TextWrapper>
    );
  }
  render() {
    const {
      newFeatures,
    } = this.props;
    return (
      <React.Fragment>
        {newFeatures &&
          <NewFeaturesWrapper>
            {this.rendertext()}
          </NewFeaturesWrapper>
        }
        {!newFeatures &&
          <TooltipWrapper id="fav_popup">
            {this.rendertext()}
          </TooltipWrapper>
        }
      </React.Fragment>
    );
  }
}

FavouritesTooltip.propTypes = {
  dictionary: PropTypes.any,
  customText: PropTypes.any,
  noStar: PropTypes.bool,
  newFeatures: PropTypes.bool,
};

export default FavouritesTooltip;